import { IDetailPageData } from "../../../shared/utils/api";

export interface IAlertCaseRecordBackendType {
    id: string,
    name: string,
    domain_type_id: string,
    process_type_id: string,
    event_id: string,
    consolidate_on_entity_id: string;
    consolidate_on_entity_type_id: string;
    domain_type: string;
    process_type: string;
    consolidate_on_entity_type: string;
    current_process_type_stage_id: string;
    creation_date: string;
    current_stage_id: string;
    current_stage_name: string;
    next_stage_id: string;
    state: string;
    alertcase_number: string;
    alertcase_id: string;
    alertcase_type_id: string;
    alertcase_type_name: string;
    assigned_to: string;
    assigned_to_name: string;
    is_user_allowed: boolean;
    last_changed_by_name: string;
    title: string;
}

export function transformToBackendAlertCaseRecord(data: IDetailPageData) {
  if (!data.id || !data.name) {
    return undefined;
  }
  return {
    id: data.id,
    name: data.name,
    domain_type_id: data.domain_type_id,
    process_type_id: data.process_type_id,
    event_id: data.event_id,
    consolidate_on_entity_id: data.consolidate_on_entity_id,
    consolidate_on_entity_type_id: data.consolidate_on_entity_type_id,
    current_stage_id: data.current_stage_id,
    current_stage_name: data.current_stage_name,
    next_stage_id: data.next_stage_id,
    state: data.state,
    alertcase_number: data.alertcase_number,
    alertcase_id: data.alertcase_id,
    alertcase_type_id: data.alertcase_type_id,
    alertcase_type_name: data.alertcase_type_name,
    assigned_to: data.assigned_to,
    assigned_to_name: data.assigned_to_name,
    last_changed_by_name: data.last_changed_by_name,
    title: data.title
  };
}
export function transformFromBackendAlertCaseRecord(backendType: IAlertCaseRecordBackendType) {
  return {
    id: backendType.id,
    name: backendType.name,
    domain_type_id: backendType.domain_type_id,
    process_type_id: backendType.process_type_id,
    event_id: backendType.event_id,
    creation_date: backendType.creation_date,
    consolidate_on_entity_id: backendType.consolidate_on_entity_id,
    consolidate_on_entity_type_id: backendType.consolidate_on_entity_type_id,
    domain_type: backendType.domain_type,
    process_type: backendType.process_type,
    consolidate_on_entity_type: backendType.consolidate_on_entity_type,
    current_process_type_stage_id: backendType.current_process_type_stage_id,
    current_stage_id: backendType.current_stage_id,
    current_stage_name: backendType.current_stage_name,
    next_stage_id: backendType.next_stage_id,
    state: backendType.state,
    alertcase_number: backendType.alertcase_number,
    alertcase_id: backendType.alertcase_id,
    alertcase_type_id: backendType.alertcase_type_id,
    alertcase_type_name: backendType.alertcase_type_name,
    assigned_to: backendType.assigned_to,
    assigned_to_name: backendType.assigned_to_name,
    last_changed_by_name: backendType.last_changed_by_name,
    title: backendType.title
  };
}
